import React from "react";
import styles from "./Considerations.module.css";
import commonStyles from "../../Shared/commonStyles.module.css";
import ConsiderationItem from "./ConsiderationItem";
import {
  FaPencilAlt,
  FaCheck,
  FaBan,
  FaCopyright,
  FaRegLightbulb,
} from "react-icons/fa";
import { IoColorPalette } from "react-icons/io5";

function Considerations() {
  return (
    <div className={`${commonStyles.section} ${styles.Considerations}`}>
      <div className={`${commonStyles.card} ${styles.ConsiderationsCard}`}>
        <h3 className={styles.cardHeader}>
          Things to Consider before Personalising
        </h3>
        <p>
          Personalised gifts are special and unique. Please review these points
          before confirming your details.{" "}
        </p>
        <div className={styles.ConsiderationList}>
          <ConsiderationItem
            icon={<FaPencilAlt className={`${styles.Icon} ${styles.Pencil}`} />}
            header="Check Your Spelling"
            points={[
              "Double-check the spelling of names, messages, and any other text you provide.",
              "Ensure that the text is exactly how you want it to appear on the product.",
            ]}
          />
          <ConsiderationItem
            icon={<IoColorPalette className={styles.Icon} />}
            header="Colours"
            points={[
              "Select from red, orange, yellow, blue, green, pink, purple, black, grey, white, gold, or silver.",
              "Check contrast between text/design and product colour.",
            ]}
          />
          <ConsiderationItem
            icon={<FaCheck className={`${styles.Icon} ${styles.Check}`} />}
            header="Accuracy"
            points={[
              "Double check all spellings, capital letters, and punctuation.",
              "Mistakes cannot be corrected once personalisation is complete.",
            ]}
          />
          <ConsiderationItem
            icon={<FaBan className={`${styles.Icon} ${styles.Ban}`} />}
            header="Product Limitations"
            points={[
              "Not all items can be personalised - look for the personalisation symbol.",
              "Some materials restrict design or text options.",
            ]}
          />
          <ConsiderationItem
            icon={
              <FaCopyright className={`${styles.Icon} ${styles.Copyright}`} />
            }
            header="Copyright & Legal"
            points={["No trademarked phrases or images."]}
          />
          <ConsiderationItem
            icon={
              <FaRegLightbulb
                className={`${styles.Icon} ${styles.Lightbulb}`}
              />
            }
            header="Need Inspiration?"
            points={[
              "Consider the recipient's preferences and style.",
              "Think about the occasion and how the personalised item will be used.",
              "Unsure of wording, design or colours? We’ll provide ideas and colour advice.",
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default Considerations;
